import { StatusType, StrokeProtocol, UrgencyType } from '../api-module/control-centre-api-client';
import { DropdownOption, DropdownSubOption } from './dropdown-option';

export class Constants {
    // Urgency related constants
    public static readonly UrgencyStat = 'ST';
    public static readonly UrgencySuperStat = 'SST';
    public static readonly UrgencyDayUrgent = 'DA';

    // Date time releated constants
    public static readonly DateFormatJson = 'YYYY-MM-DD';
    public static readonly DateFormat_DDMMYY = 'DD/MM/YYYY';
    public static readonly DateFormat_ddMMyyy = 'd/M/yyyy';
    public static readonly DateFormatDateOnly = 'dd/MM/yyyy';
    public static readonly DateFormatFullDatetime = 'dd/MM/yyyy HH:mm:ss';
    public static readonly DateFormatFullDatetimeNoSeconds = 'dd/MM/yyyy HH:mm';

    public static readonly AccessionNumberPattern = '[a-zA-Z0-9-_]*';

    public static readonly UnableToContactServerMessage =
        'Unable to contact server. Please try again in some time. ' + 'If the issue persists, please contact Everlight support team';

    public static readonly UnableToFindResourceMessage =
        'A required resource could not be found. Please try again in some time. ' +
        'If the issue persists, please contact the Everlight support team.';

    public static readonly BadRequestMessage =
        'There was an error with your request. Please check for errors and try again. ' +
        'If there are no errors with the request, please contact the Everlight support team.';

    public static readonly ConflictErrorMessage =
        'This entity has recently been updated, please reload. If the issue persists, ' + 'please contact the Everlight support team.';

    public static readonly InternetConnectionLostMessage = 'Internet connection lost';

    public static readonly InternetConnectionRestoredMessage = 'Internet connection restored';

    public static readonly UnauthenticatedMessage =
        'You have logged out. The details entered on this form have not been saved. ' + 'Please login and and submit the order again';

    public static readonly UserBlockedMessage = 'Your account is not active. Please contact Everlight support to resolve this issue.';

    public static readonly Auth0GenericErrorMessage =
        'Something went wrong with Control Centre. Please refresh the page and ' +
        'try again. If the issue persists, please contact Everlight support team';

    public static readonly UrgencyUpdateErrorMessage = 'This value cannot be edited. If this data is incorrect, please call Ops to edit.';

    public static readonly CannotFindRoles =
        'Cannot find the roles. Please refresh the page. If the issue persists, ' + 'please contact Everlight support team.';

    public static readonly UserSuccessfullyUpdated = 'The user has been successfully updated.';

    public static readonly UserCannotBeUpdated = 'The user cannot be updated. Please resolve the errors.';

    public static readonly UserSettingError = 'UserSettingError';

    public static readonly UserPermissionError = 'UserPermissionError';

    public static readonly HttpTimeoutMseconds = 15000;

    public static readonly PeriodicReloadTimeout = 900000; // 15 minutes

    public static readonly HttpRetry = 3;

    // Phone number related constants, Copied from Orders.Component.ts.
    public static readonly PhonePattern = '[0-9]*';

    public static readonly PhoneExtensionBrief = 'ext';

    public static readonly MaxSizePhoneExtension = 10;

    public static readonly FullPhonePattern = /^[\+ ]?[\d ]*((ext|x)[\d ]+)?$/;

    // This regex has problem with \-.
    public static readonly NamePattern = "[a-zA-ZÀ-ž\u0370-\u03FF\u0400-\u04FF][0-9a-zA-ZÀ-ž\u0370-\u03FF\u0400-\u04FF,.@'-_^ ]*";
    public static readonly LocationNamePattern = /^[0-9a-zA-ZÀ-ž\u0370-\u03FF\u0400-\u04FF,.'@\*\-_^ ]*$/;
    public static readonly MrnPattern = '[a-zA-Z0-9-_#$.]*'; // This regex has problem with \-.

    public static readonly UrgencyDescriptions: Map<UrgencyType, string> = new Map<UrgencyType | null, string>([
        [UrgencyType.Routine, 'Routine'],
        [UrgencyType.Urgent, 'Urgent'],
        [UrgencyType.Trauma, 'Trauma'],
        [UrgencyType.Stroke, 'Stroke'],
        [UrgencyType.TraumaAndStroke, 'Trauma, Stroke']
    ]);
    public static readonly UrgencyDropdownOptions: DropdownOption<UrgencyType | StrokeProtocol>[] = [
        new DropdownOption('Standard Urgent', UrgencyType.Urgent),
        new DropdownOption('Polytrauma', UrgencyType.Trauma),
        new DropdownOption('Stroke', UrgencyType.Stroke)
    ];
    public static readonly StrokeDropdownOptions: DropdownSubOption<StrokeProtocol>[] = [
        new DropdownSubOption('Thrombectomy', StrokeProtocol.Thrombectomy),
        new DropdownSubOption('Thrombolysis', StrokeProtocol.Thrombolysis),
        new DropdownSubOption('Simple Stroke', StrokeProtocol.SimpleStroke)
    ];
    public static readonly StatusDescriptions: Map<StatusType, string> = new Map<StatusType | null, string>([
        [StatusType.AwaitingFurtherDetails, 'Awaiting Further Details'],
        [StatusType.AwaitingImages, 'Awaiting Images'],
        [StatusType.ReadyToReport, 'Ready to Report'],
        [StatusType.Reporting, 'Reporting'],
        [StatusType.TransferringImages, 'Transferring Images'],
        [StatusType.Reported, 'Reported'],
        [StatusType.Cancelled, 'Cancelled'],
        [StatusType.OnHoldMissingClinicalHistory, 'On Hold - Missing Clinical History'],
        [StatusType.OnHoldMissingImages, 'On Hold - Missing Images'],
        [StatusType.OnHoldMissingDocumentation, 'On Hold - Missing Documentation'],
        [StatusType.OnHoldMissingPriors, 'On Hold - Missing Priors'],
        [StatusType.OnHoldReviewOrderDetails, 'On Hold - Review Order Details'],
        [StatusType.OnHoldMissingPriorImages, 'On Hold - Missing Prior Images'],
        [null, 'Status Pending'],
        [undefined, 'Status Pending']
    ]);

    public static readonly SeperatorInNotes = '\r\n';
}
